import { __decorate } from "tslib";
import { ArrayDecoder, field } from '@simonbackx/simple-encoding';
import { Payment } from './Payment';
import { RegistrationWithMember } from './RegistrationWithMember';
export class PaymentWithRegistrations extends Payment {
}
__decorate([
    field({ decoder: new ArrayDecoder(RegistrationWithMember) })
], PaymentWithRegistrations.prototype, "registrations", void 0);
//# sourceMappingURL=PaymentWithRegistrations.js.map